<script setup lang="ts">
import { useRoute } from "vue-router";
import { computed } from "vue";
const { isDesktop, isMobile } = useDevice();
const route = useRoute();

const breadCrumbRoutes = computed(() => {
  const segments = route.path.split("/").filter(Boolean);

  const crumbs = segments.map((segment, index) => ({
    name: decodeURIComponent(segment.replace(/-/g, " ")),
    to: "/" + segments.slice(0, index + 1).join("/"),
  }));

  const allCrumbs = [{ name: "Home", to: "/" }, ...crumbs];

  if (isMobile) {
    const home = allCrumbs[0];
    const current = allCrumbs[allCrumbs.length - 1];
    if (current !== home) return [home, current];
    return [home];
  }

  return allCrumbs;
});
</script>

<template>
  <nav
    class="max-w-screen-xl px-4 mx-auto flex items-center gap-1 text-sm tracking-[0.5px] z-30"
  >
    <template v-for="(crumb, index) in breadCrumbRoutes" :key="crumb.to">
      <NuxtLink
        :to="crumb.to"
        class="capitalize hover:underline text-base first:shrink-0"
        :class="{
          'font-bold': index === breadCrumbRoutes.length - 1,
          'font-semibold': isMobile && index === breadCrumbRoutes.length - 1,
          'text-sm line-clamp-1': isMobile,
        }"
      >
        {{ crumb.name }}
      </NuxtLink>
      <span v-if="index !== breadCrumbRoutes.length - 1" class="mx-1 text-base"
        >›</span
      >
    </template>
  </nav>
</template>
